import { createSelector } from 'reselect'

const getSquad = state => state.squad
const getRoster = state => state.roster
const getEquipment = state => state.equipment
const getInventory = state => state.inventory

const getSquadFromRoster = createSelector(
    getSquad,
    getRoster,
    (squad, roster) => (Object.values(roster).filter(unit => squad.includes(unit.ID)))
)

const getSquadWithEquipment = createSelector(
    getSquadFromRoster,
    getEquipment,
    getInventory,
    (actors, equipment, inventory) => (actors.map((actor) => {
        const itemList = Object.values(equipment).reduce((arr, entry) => {
            if (entry.unitID === actor.ID) { arr.push(entry.itemID) }
            return arr
        }, [])
        const items = inventory.filter(item => itemList.includes(item.ID))
        return Object.assign({}, actor, { equipment: items })
    }))
)

export default getSquadWithEquipment

